export function formatCurrency(number: number, currency = 'pt-BR') {
    if (!number) {
        return '0,00'
    }
    const numberFormatted = Number(
        String(number).replace(',', '.')
    ).toLocaleString(currency, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })

    return numberFormatted
}

export function formatBirthDate(event, setFormattedBirthDate) {
    const value = event.target.value

    const numericValue = value.replace(/\D/g, '').slice(0, 8)

    const newValue = numericValue
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')

    setFormattedBirthDate(newValue)
}

export function formatCep(event, setFormattedCEP) {
    const value = event.target.value

    const numericValue = value.replace(/\D/g, '').slice(0, 8)

    const newValue = numericValue.replace(/^(\d{5})(\d)/, '$1-$2')

    setFormattedCEP(newValue)
}

export function formatCpf(event, setFormattedCPF) {
    const value = event.target.value

    const numericValue = value.replace(/\D/g, '').slice(0, 11)

    const newValue = numericValue
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{2})$/, '$1-$2')

    setFormattedCPF(newValue)
}

export function formatPhone(event, setFormattedPhone) {
    const value = event.target.value

    const numericValue = value.replace(/\D/g, '').slice(0, 11)

    let newValue

    if (numericValue.length <= 10) {
        newValue = numericValue
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{4})(\d{4})/, '$1-$2')
    } else {
        newValue = numericValue
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d{4})/, '$1-$2')
    }

    setFormattedPhone(newValue)
}

export function formatDateMonthYear(event, setFormattedDateMonthYear) {
    const value = event.target.value

    const numericValue = value.replace(/\D/g, '').slice(0, 4)

    let newValue = numericValue

    if (numericValue.length >= 3) {
        newValue = numericValue.replace(/(\d{2})(\d)/, '$1/$2')
    }

    setFormattedDateMonthYear(newValue)
}
